import styled from '@emotion/styled'
import { t } from 'i18next'
import { useState } from 'react'
import { AnalyticsTypeEnum } from '../../../core/enums/analytics-type.enum'

const Background = styled.div`
  background: #4e4e4e;
  display: flex;
  justify-content: space-between;
`

const Option = styled.p`
  flex-grow: 1;
  color: #f3f3f3;
  text-align: center;
  align-self: center;
  padding: 5px;
  margin: 3px;
  border-radius: 3px;
`

type Props = {
  analyticsType: AnalyticsTypeEnum
  onToggleButtonClick: (value: boolean) => void
}

const SearchTypeToggle = ({ analyticsType, onToggleButtonClick }: Props) => {
  const [isSearchingByWork, setIsSearchingByWork] = useState<boolean>(
    analyticsType === AnalyticsTypeEnum.WORK_MIRROR ||
      analyticsType === AnalyticsTypeEnum.PRIVATE_WORK_MIRROR,
  )
  const handleToggle = (toggle: boolean) => {
    setIsSearchingByWork(toggle)
    onToggleButtonClick(toggle)
  }

  return (
    <Background>
      <Option
        onClick={() => handleToggle(true)}
        className={isSearchingByWork ? 'bg-white' : ''}
        style={isSearchingByWork ? { color: '#323232' } : {}}
      >
        {t('webApp.ranks.filters.toggleMirrorType.byWork')}
      </Option>
      <Option
        onClick={() => handleToggle(false)}
        className={isSearchingByWork ? '' : 'bg-white'}
        style={isSearchingByWork ? {} : { color: '#323232' }}
      >
        {t('webApp.ranks.filters.toggleMirrorType.byAuthor')}
      </Option>
    </Background>
  )
}

export default SearchTypeToggle
